import { oneLine } from 'common-tags';

import { pickChild } from '@/lib/utils';
import { default as TwoColumnExport } from '.';

import type { FunctionComponent } from 'react';
import type { TypeTwoColumnProps } from './types';

/**
 * Permite intercambiar las columnas pero este comportamiento solo
 * ocurre en desktop, en mobile la primera columna siempre irá arriba.
 */
export const TwoColumn: FunctionComponent<TypeTwoColumnProps> = ({
  className = '',
  gap = '',
  reverse = false,
  children,
  ...props
}: TypeTwoColumnProps) => {
  const [, Right] = pickChild(children, TwoColumnExport.Right);
  const [, Left] = pickChild(children, TwoColumnExport.Left);

  return (
    <div
      className={`grid grid-cols-1 md:grid-cols-[1fr_1fr] ${gap} ${className}`}
      {...props}
    >
      {Left && (
        <Left.type
          {...(Left.props as Record<string, unknown>)}
          className={oneLine` ${reverse ? 'order-2' : 'order-1'} ${(Left.props as { className?: string }).className ?? ''} `}
        />
      )}

      {Right && (
        <Right.type
          {...(Right.props as Record<string, unknown>)}
          className={oneLine` ${reverse ? 'order-1' : 'order-2'} ${(Right.props as { className?: string }).className ?? ''} `}
        />
      )}
    </div>
  );
};
